module.exports = __webpack_public_path__ + "static/media/navicon.3b4464f2.svg";